import axios from 'axios'

const api = axios.create({
    baseURL: 'https://fab.kaspper.com.br/api'
})

export default api